export const locationsList = [
  {
    id: 1,
    postcode: "3000",
    suburb: "MELBOURNE",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: -37,
      longitude: 144,
    },
  },
  {
    id: 2,
    postcode: "3006",
    suburb: "SOUTHBANK",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 3,
    postcode: "3018",
    suburb: "ALTONA",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 4,
    postcode: "3016",
    suburb: "WILLIAMSTOWN",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 5,
    postcode: "3039",
    suburb: "MOONEE PONDS",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 6,
    postcode: "3036",
    suburb: "KEILOR",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 7,
    postcode: "3052",
    suburb: "PARKVILLE",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 8,
    postcode: "3053",
    suburb: "CARLTON",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 9,
    postcode: "3054",
    suburb: "CARLTON NORTH",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 10,
    postcode: "3056",
    suburb: "BRUNSWICK",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 11,
    postcode: "3058",
    suburb: "COBURG",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 12,
    postcode: "3059",
    suburb: "GREENVALE",
    state: "Victoria",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
  {
    id: 100,
    postcode: "5723",
    suburb: "COOBER PEDY",
    state: "South Australia",
    country: "AU",
    geolocation: {
      latitude: null,
      longitude: null,
    },
  },
];
